<template>
  <div class="hello">
    <img alt="Vue logo" src="@/assets/logo.png">
    <h1>カテコンにようこそ</h1>
    <footer>
      <a href="/privacy">利用規約・プライバシーポリシー</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #4472c4;
}
</style>
